import Embed from "./blocks/embed";
import { StructuredText } from "react-datocms";
import BlockPostImage from "./blocks/blockPostImage";
import BlockSpanHeader from "./blocks/blockSpanHeader";
import BlockRelatedItems from "./blocks/blockRelatedItems";
import BlockMissing from "./blocks/blockMissing";
import CTAPicker from "./blocks/ctas/CTAPicker";
import FAQ from "./blocks/FAQ";

export default function PostBody({ content, alignment, wrapperClass }) {
  wrapperClass = wrapperClass ? wrapperClass : "max-w-2xl mx-auto";
  let alignmentClass = `flex flex-col text-${alignment}`;
  alignmentClass += ` ${alignment === "center" ? "items-center" : ""}`;
  alignmentClass += ` ${alignment === "right" ? "items-end" : ""}`;
  return (
    <div className={alignmentClass}>
      <div className={wrapperClass}>
        <div className="prose prose-lg prose-blue">
          <StructuredText
            data={content}
            renderBlock={({ record }) => {
              switch (record._modelApiKey) {
                case "span":
                  return <BlockSpanHeader record={record} />;
                case "block_post_image":
                  return <BlockPostImage record={record} />;
                case "cta_picker":
                  return <CTAPicker record={record} />;
                case "embed":
                  return <Embed record={record} />;
                case "text":
                  return <Text item={item} />;
                case "faq_section":
                  return <FAQ record={record} />;
                default:
                  return <BlockMissing record={record} />;
              }
            }}
            renderLinkToRecord={({ record, children, transformedMeta }) => {
              switch (record.__typename) {
                case "PageRecord":
                  return (
                    <a
                      className="link-blue"
                      {...transformedMeta}
                      href={`/${record.slug}`}
                    >
                      {children}
                    </a>
                  );
                case "ProductRecord":
                  return (
                    <a
                      className="link-blue"
                      {...transformedMeta}
                      href={`/${record.slug}`}
                    >
                      {children}
                    </a>
                  );
                case "ResourceRecord":
                  let url;
                  url = record.externalUrl ? record.externalUrl : `/resources/${record.slug}`;
                  return (
                    <a
                      className="link-blue"
                      {...transformedMeta}
                      href={url}
                    >
                      {children}
                    </a>
                  );
                case "BlogpostRecord":
                  return (
                    <a
                      className="link-blue"
                      {...transformedMeta}
                      href={`/blog/${record.slug}`}
                    >
                      {children}
                    </a>
                  );
                default:
                  return null;
              }
            }}
            renderInlineRecord={({ record }) => {
              switch (record.__typename) {
                case "PageRecord":
                  return (
                    <a className="link-blue" href={`/${record.slug}`}>
                      {record.title}
                    </a>
                  );
                case "ProductRecord":
                  return (
                    <a className="link-blue" href={`/${record.slug}`}>
                      {record.title}
                    </a>
                  );
                case "ResourceRecord":
                  return (
                    <a className="link-blue" href={record.externalUrl}>
                      {record.title}
                    </a>
                  );
                case "BlogpostRecord":
                  return (
                    <a className="link-blue" href={`/blog/${record.slug}`}>
                      {record.title}
                    </a>
                  );
                default:
                  return null;
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}
